var __rspack_ns_object = JSON.parse('{"Tracked series":"{{trackedSeries}} séries rastreadas"}')